<template>
  <button class="PaB-button" :class="buttonClasses" :disabled="disabled">
    <slot name="before"></slot>
    <span class="button__text" v-if="label">{{ label }}</span>
    <slot name="after"></slot>
  </button>
</template>

<style lang="scss">
.PaB-button {
  display: flex;
  align-items: center;
  text-align: center;
  position: relative;
  border: 2px solid #b2b2b2;
  padding: 0 12px;
  min-height: 44px;
  white-space: nowrap;
  justify-content: center;
  background-color: transparent;
  cursor: pointer;
  font-size: 15px;
  transition: all 0.2s linear;
  font-family: inherit;
  line-height: 40px;

  &:hover,
  &:focus {
    background-color: #f0f0f0;
  }

  &--rounded {
    border-radius: 3px;
  }

  &--icon {
    svg {
      display: block;
      flex: 0 0 auto;
    }

    .button__text {
      display: none;
      padding: 5px;

      @media screen and (min-width: 600px) {
        display: block;
      }
    }
  }

  &--default {
    border: 1px solid #b2b2b2;
    color: #242424;

    &:hover,
    &:focus {
      background-color: #f0f0f0;
    }
  }

  &--primary {
    color: #fff !important;
    text-transform: uppercase;
  }

  &--secondary {
    background-color: transparent;
    text-transform: uppercase;
  }

  &--alternative {
    background-color: white;
    text-transform: uppercase;
    border-color: #b2b2b2 !important;
    color: #000000;
    &:hover,
    &:focus {
      background-color: white;
    }

  }

  &--extra {
    border-color: #6DBAD5 !important;
    color: white;
    background-color: #6DBAD5;
    text-transform: uppercase;
    &:hover,
    &:focus {
      background-color: #6DBAD5;
    }
  }

  &--block {
    display: block;
    width: 100%;
  }

  &--plain {
    border-color: transparent;
  }

  &--blank {
    background-color: transparent;
    border-color: transparent;
    padding: 0;
    margin: 0;
    color: currentColor;
  }

  &--disabled,
  &:disabled {
    cursor: not-allowed;
    filter: grayscale(100%) opacity(40%);
  }
}
.PaB-button-group {
  .PaB-button {
    margin-bottom: 15px;
  }
}
</style>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'default'
    },
    block: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    widgetTheme () {
      if (this.type === 'primary') {
        return {
          backgroundColor: 'color_primary',
          borderColor: 'color_primary'
        }
      } else if (this.type === 'secondary') {
        return {
          color: 'color_primary',
          borderColor: 'color_primary'
        }
      }

      return {}
    },
    widgetThemeHover () {
      if (this.type === 'primary') {
        return {
          backgroundColor: 'color_primary_hover',
          borderColor: 'color_primary_hover'
        }
      } else if (this.type === 'secondary') {
        return {
          color: 'color_primary_hover',
          borderColor: 'color_primary_hover'
        }
      }

      return {}
    },
    buttonClasses () {
      let classes = this.classes
      classes += ` PaB-button--${this.type}`
      classes += this.icon ? ' PaB-button--icon' : ''
      classes += this.rounded ? ' PaB-button--rounded' : ''
      classes += this.block ? ' PaB-button--block' : ''
      classes += this.disabled ? ' PaB-button--disabled' : ''
      return classes
    }
  }
}
</script>
